import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

interface PermissionGuardProps {
  permissions?: string | string[];
  userType?: 'admin' | 'franchise';
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permissions,
  userType,
  fallback,
  children
}) => {
  // 一時的に権限チェックを無効化、デモ用にchildrenを直接返す
  // 本番環境では完全な権限検証ロジックを有効にすべき
  return <>{children}</>;
  
  // 以下是完整的权限認証逻辑，演示时临时注释
  /*
  const navigate = useNavigate();
  const auth = useSelector((state: RootState) => state.auth);
  const franchise = useSelector((state: RootState) => state.franchise);

  // 检查ユーザー是否ログイン
  const isAuthenticated = userType === 'franchise' 
    ? franchise.isAuthenticated 
    : auth.isAuthenticated;

  if (!isAuthenticated) {
    return (
      <Result
        status="403"
        title="未ログイン"
        subTitle="お先ログイン后アクセス此ページ"
        extra={
          <Button type="primary" onClick={() => navigate('/login')}>
            去ログイン
          </Button>
        }
      />
    );
  }

  // 检查ユーザー类型权限
  if (userType === 'admin' && auth.user?.role !== 'admin') {
    return (
      <Result
        status="403"
        title="权限不足"
        subTitle="您没有权限アクセス管理员ページ"
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            返回首页
          </Button>
        }
      />
    );
  }

  if (userType === 'franchise' && !franchise.isAuthenticated) {
    return (
      <Result
        status="403"
        title="权限不足"
        subTitle="您没有权限アクセスフランチャイズ商ページ"
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            返回首页
          </Button>
        }
      />
    );
  }

  // 检查具体权限
  if (permissions) {
    const requiredPermissions = Array.isArray(permissions) ? permissions : [permissions];
    const userPermissions = userType === 'franchise' 
      ? franchise.permissions 
      : auth.user?.permissions || [];

    const hasPermission = requiredPermissions.every(permission =>
      userPermissions.includes(permission)
    );

    if (!hasPermission) {
      if (fallback) {
        return <>{fallback}</>;
      }

      return (
        <Result
          status="403"
          title="权限不足"
          subTitle="您没有权限执行此操作"
          extra={
            <Button type="primary" onClick={() => navigate(-1)}>
              返回上一页
            </Button>
          }
        />
      );
    }
  }

  return <>{children}</>;
  */
};

export default PermissionGuard;